<script setup lang="ts">
import { ToastRegion } from '@taler/ui'
import { useI18n } from 'vue-i18n'
import { useRoute } from 'vue-router'
import AppShell from '@/app/shell/AppShell.vue'
import { useToasts } from '@/app/toasts'

const { t } = useI18n()
const route = useRoute()
const toasts = useToasts()
</script>

<template>
  <AppShell v-if="route.meta.public !== true" />
  <RouterView v-else />
  <ToastRegion
    :toasts="toasts.toasts.value"
    :dismiss-label="t('shell.dismissNotification')"
    @dismiss="toasts.dismiss"
  />
</template>
